<template>
  <div class="table-container">
    <div class="related-kpi">
      <div class="kpi-info-row row" v-bind:class="{'extendable-row': typeof kpiData.children !== 'undefined'}" v-on:click="toggleChildren">
        <div class="col-7" v-bind:style="{ paddingLeft: 40 * level + 'px'}">
          <span v-show="!childrenVisible && typeof kpiData.children !== 'undefined'">&#x25b6;</span>
          <span v-show="childrenVisible && typeof kpiData.children !== 'undefined'">&#x25BC;</span>
          {{ kpiData.name }}
        </div>
        <div class="col-2">
          <template v-if="kpiData.last_performance.target || kpiData.last_performance.target === 0">{{ kpiData.last_performance.target }} {{ kpiData.last_performance.unit}}</template>
        </div>
        <div class="col-2">
         <template v-if="kpiData.last_performance.value || kpiData.last_performance.value === 0">
            <i class="ti-check text-success" v-if="kpiData.last_performance.value >= kpiData.last_performance.target"></i>
            <i class="ti-alert text-danger" v-if="kpiData.last_performance.value < kpiData.last_performance.target"></i>
            <b v-bind:class="[kpiData.last_performance.value >= kpiData.last_performance.target ? 'text-success' : 'text-danger']">{{ kpiData.last_performance.value }} {{ kpiData.last_performance.unit }} </b>
        </template>
        </div>
        <div class="col-1">
          <button v-on:click="openModal" class="btn btn-link view-button overrule">{{ $t("View") }}</button>
        </div>
      </div>
      <related-kpi-row v-show="childrenVisible" v-for="child in getChildren(kpiData)" :kpiData="child" :level="level + 1" :key="child.uid"></related-kpi-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RelatedKpiRow",
    props: ['kpiData', 'level'],
    data: function() {
      return {
        childrenVisible: false
      }
    },
    methods: {
      getChildren: function (parent) {
        if (typeof parent.children === 'undefined') {
          return [];
        } else {
          return parent.children;
        }
      },
      toggleChildren: function () {
        this.childrenVisible = !this.childrenVisible;
      },
      openModal: function () {
        let parent = this.$parent;
        console.log(parent.$options.name);
        while(parent.$options.name !== "KpiDetailsModal"){
          parent = parent.$parent;
        }
        console.log(parent);
        for(let i = 0; i < parent.kpiWidgetModals.length; i++){
          if(parent.kpiWidgetModals[i].id === this.kpiData.uid){
            parent.kpiWidgetModals[i].open = true;
          }
        }
      }
    }
  }
</script>

<style scoped>
  .related-kpi{
    padding-left: 8px;
  }
  .table-container:nth-child(even){
    background-color: #f0f0f0;
  }
  .table-container:nth-child(odd){
    background-color: #f5f5f5;
  }
  .kpi-info-row{
    margin-left: 0px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .view-button{
    color: #1bb5eb;
    float: right;
  }
  .extendable-row{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/RelatedKpiRow.vue